// import Tab from "bootstrap/js/dist/tab";  
import './AutoDealerships.css';
import AIheader from "../../RentAI/AIheader";
import Footer from "../../../Component/Footer/Footer";
import ScrollingAnounce from "../../../Component/GetAroundpage/ScrollingAnounce/ScrollingAnounce";
import EasySetup from "../../../Component/GetAroundpage/EasySetup/EasySetup";
import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
// import CarRentalFaq from "../../../Component/Solutions/CarRentalFaq/CarRentalFaq"
import BetaWaitlist from '../../../Component/Beta-Waitlist/BetaWaitlist';
import PopularBlog from '../../../Component/blog/PopularBlog/PopularBlog';

const AutoDealerships = ()=> {

     
    const [isClient, setIsClient] = useState(false);
    const [showWaitlist, setShowWaitlist] = useState(false);
   // const [isDealershipOpen, setDealershipOpen] = useState(false);

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
          setTimeout(() => {
            const element = document.querySelector(hash);
            if (element) {
              const headerOffset = 80; // Adjust according to your header height
              const elementPosition = element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementPosition - headerOffset,
                behavior: "smooth",
              });
            }
          }, 100); // Delay to ensure DOM is loaded
        }
      }, []);
      

    useEffect(() => {
      setIsClient(true);
    }, []);
  
    if (!isClient) return null;
   


    return (
        <>
        <AIheader/>
        <BetaWaitlist
        showJoinWaitList={showWaitlist}
        onClose={() => setShowWaitlist(false)}
        onOpen={() => setShowWaitlist(true)}
        />

            {/* START bannerCarRentalMain */}
            <section className="bannerCarRentalMain bannerDealershipMain">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                    <div className="col-lg-6">
                            <div className="bannerCarRentalLeft">
                                <small>AUTO DEALERSHIPS</small>
                                <h1>Dealership rental software for the modern customer</h1>
                                <p>Convert test drives, rentals, and subscriptions seamlessly into profitable vehicle sales with an all-in-one solution.
                                </p>
                                <div className="carRentalBtn">
                                <button onClick={() => setShowWaitlist(true)} className="btn btnBlue">
                                    Join Waitlist
                                    </button>
                                    <a className="btn btnTransparent" href="/contact-sales">Contact Sales</a>
                                </div> 
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="bannerCarRentalRight">
                                <figure>
                                    <img className='img-fluid' src="/img/Solutions/dealerships_banner.webp" alt="rent id"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bannerCarRentalMain */}


            {/* START whyCarRentalMain */}
            <section className="whyCarRentalMain whyDealershipMain">
                <div className="container">
                    <div className="whyCarRentalOuter">   
                        <div className='row align-items-center'>
                            <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='whyCarRentalLeft'>
                                    <small>MODERN AUTO DEALERSHIPS</small>
                                    <h2>Serving Your<br/> Community &<br/> Building Trust</h2>
                                </div>
                            </div>
                            <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='whyCarRentalRight'>
                                    <ul>
                                        <li>
                                            <h4>The Journey from Rental to Sale</h4>
                                            <p>Monetize every step of the journey – from test drives to rentals to subscriptions – and convert more leads into buyers.
                                            </p>
                                        </li>
                                        <li>
                                            <h4>The Now Generation Rental Platform</h4>
                                            <p>Give modern renters who use ride-sharing and car-sharing apps a reason to choose your dealership with your own app-powered rental system.</p>
                                        </li>
                                        <li>
                                            <h4>Reduce Risk with Trust and Safety Tools</h4>
                                            <p>Renter ID verification, personal insurance validation, risk scoring and built-in vehicle tracking keep the business secure.</p>
                                        </li>
                                        <li>
                                            <h4>On-Rent Embedded Insurance & Protection</h4>
                                            <p>Customers can use their personal insurance or choose our primary coverage options  to be sure your vehicle are  protected</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END whyCarRentalMain */}


            {/* START testDriveMain */}
            <section className="testDriveMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="testDriveHead">
                                <h2>From Test Drive to Ownership</h2>
                                <p>Rentid transforms a simple test drive into a seamless pathway to long-term revenue.</p>
                            </div>
                        </div>
                    </div>
                    <div className="swiper backgound_gradient">
                        <div className="swiper-wrapper" aria-live="polite">
                            <div className="swiper-slide gradient_slide" aria-label="1 / 5">
                                <div sticky-image="0" className="rd_marron"></div>
                            </div>
                            <div className="swiper-slide gradient_slide" aria-label="2 / 5">
                                <div sticky-image="1" className="rd_forest"></div>
                            </div>
                            <div className="swiper-slide gradient_slide" aria-label="3 / 5">
                                <div sticky-image="2" className="rg_pink"></div>
                            </div>
                            <div className="swiper-slide gradient_slide" aria-label="4 / 5">
                                <div sticky-image="3" className="rg_red"></div>
                            </div>
                            <div className="swiper-slide gradient_slide" aria-label="5 / 5">
                                <div sticky-image="3" className="rg_red"></div>
                            </div>
                        </div>
                    </div>

                    <div className="testDriveOuter">
                        <div id="scroll-block" className="testDriveLeft">
                            <div scrolling-block="0" className="scrolling_item">
                                <div className="testDriveInner">
                                    <h3>Extended Test Drive Protection</h3>
                                    <h4>Give customers a no-risk, extended drive while keeping your dealership covered.</h4>
                                    <ul>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Instantly verify driver credentials with RentID.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Provide proper insurance coverage for every test drive.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Reduce liability while increasing buyer confidence.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div scrolling-block="1" className="scrolling_item">
                                <div className="testDriveInner">
                                    <h3>Loaner Vehicles, Simplified</h3>
                                    <h4>Frictionless loaner car management with instant contracting & insurance validation.</h4>
                                    <ul>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Mobile-based contracting and insurance validation in seconds.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Reduce wait times with automated check-in and return.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Improve customer satisfaction and retention.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div scrolling-block="2" className="scrolling_item">
                                <div className="testDriveInner">
                                    <h3>Flexible Rentals</h3>
                                    <h4>Monetize inventory with short-term rentals between test drives and sales.</h4>
                                    <ul>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Rent vehicles during idle periods to maximize earnings.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Manage pricing, contracts, and bookings with RentDirect.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Control your fleet with real-time tracking and insights.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>


                            <div scrolling-block="3" className="scrolling_item">
                                <div className="testDriveInner">
                                    <h3>Subscription Models</h3>
                                    <h4>Capture long-term revenue from customers who aren’t ready to buy.</h4>
                                    <ul>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Offer customers month-to-month access instead of pushing for a sale.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Provide multiple price tiers and vehicle options.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Build loyalty with ongoing customer relationships.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div scrolling-block="4" className="scrolling_item">
                                <div className="testDriveInner">
                                    <h3>Convert Rentals into Sales</h3>
                                    <h4>Track usage, personalize offers, and convert rental customers into buyers.</h4>
                                    <ul>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Track rental history and tailor exclusive purchase offers.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Allow renters to apply part of their rental payments toward a down payment.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Capture leads who want to try before they buy.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="testDriveRight">
                            <div className="mobile_bg">
                                <div className="background_grain_black">
                                    <div className="grains_image"></div>
                                </div>
                            </div>
                            <div className="swiper scrolling-images">
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide scrolling_image_slide" role="group" aria-label="1 / 5">
                                        <div className="changing_img">
                                            <div className="testDriveAuto">
                                                <img className="contain_image" width="750" src="/img/Solutions/test_drive_1.webp" alt='demo' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide scrolling_image_slide" role="group" aria-label="2 / 5">
                                        <div className="changing_img">
                                            <div className="testDriveAuto">
                                                <img className="contain_image" width="750" src="/img/Solutions/test_drive_2.webp" alt='demo' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide scrolling_image_slide" role="group" aria-label="3 / 5">
                                        <div className="changing_img">
                                            <div className="testDriveAuto">
                                                <img className="contain_image" width="750" src="/img/Solutions/test_drive_3.webp" alt='demo' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide scrolling_image_slide" role="group" aria-label="4 / 5">
                                        <div className="changing_img">
                                            <div className="testDriveAuto">
                                                <img className="contain_image" width="750" src="/img/Solutions/test_drive_4.webp" alt='demo' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide scrolling_image_slide" role="group" aria-label="5 / 5">
                                        <div className="changing_img">
                                            <div className="testDriveAuto">
                                                <img className="contain_image" width="750" src="/img/Solutions/test_drive_5.webp" alt='demo' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>


            <section className="testDriveMobileMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="testDriveHead">
                                <h2>From Test Drive to Ownership</h2>
                                <p>Rentid transforms a simple test drive into a seamless pathway to long-term revenue.</p>
                            </div>
                        </div>
                    </div>

                    {/* start 1 */}
                    <div className="testDriveMobileOuter">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="testDriveMobileLeft">
                                    <h3>Extended Test Drive Protection</h3>
                                    <h4>Give customers a no-risk, extended drive while keeping your dealership covered.</h4>
                                    <ul>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Instantly verify driver credentials with RentID.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Provide proper insurance coverage for every test drive.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Reduce liability while increasing buyer confidence.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="testDriveMobileRight">
                                    <img className="img-fluid" src="/img/Solutions/test_drive_1.webp" alt='demo' />
                                </div>
                            </div>
                        </div>
                    </div>
 
                    {/* start 2 */}
                    <div className="testDriveMobileOuter">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="testDriveMobileLeft">
                                    <h3>Loaner Vehicles, Simplified</h3>
                                    <h4>Frictionless loaner car management with instant contracting & insurance validation.</h4>
                                    <ul>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Mobile-based contracting and insurance validation in seconds.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Reduce wait times with automated check-in and return.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Improve customer satisfaction and retention.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="testDriveMobileRight">
                                    <img className="img-fluid" src="/img/Solutions/test_drive_2.webp" alt='demo' />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* start 3 */}
                    <div className="testDriveMobileOuter">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="testDriveMobileLeft">
                                    <h3>Flexible Rentals</h3>
                                    <h4>Monetize inventory with short-term rentals between test drives and sales.</h4>
                                    <ul>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Rent vehicles during idle periods to maximize earnings.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Manage pricing, contracts, and bookings with RentDirect.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Control your fleet with real-time tracking and insights.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="testDriveMobileRight">
                                    <img className="img-fluid" src="/img/Solutions/test_drive_3.webp" alt='demo' />
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* start 4 */}
                    <div className="testDriveMobileOuter">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="testDriveMobileLeft">
                                    <h3>Subscription Models</h3>
                                    <h4>Capture long-term revenue from customers who aren’t ready to buy.</h4>
                                    <ul>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Offer customers month-to-month access instead of pushing for a sale.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Provide multiple price tiers and vehicle options.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Build loyalty with ongoing customer relationships.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="testDriveMobileRight">
                                    <img className="img-fluid" src="/img/Solutions/test_drive_4.webp" alt='demo' />
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    {/* start 5 */}
                    <div className="testDriveMobileOuter">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="testDriveMobileLeft">
                                    <h3>Convert Rentals into Sales</h3>
                                    <h4>Track usage, personalize offers, and convert rental customers into buyers.</h4>
                                    <ul>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Track rental history and tailor exclusive purchase offers.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Allow renters to apply part of their rental payments toward a down payment.</span>
                                        </li>
                                        <li>
                                            <img width="24px" src="/img/Solutions/checkmark-circle-blue.svg" alt="icon"/>
                                            <span>Capture leads who want to try before they buy.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="testDriveMobileRight">
                                    <img className="img-fluid" src="/img/Solutions/test_drive_5.webp" alt='demo' />
                                </div>
                            </div>
                        </div>
                    </div>
                     {/* end */}
                     
                </div>
            </section>
            {/* end testDriveMain */}

            {/* START choiceFormerMain */}
            <section className='gigDeliveryMain gigDealershipMain'>
                <div className='container-fluid'>
                    <div className="row jusify-content-center align-items-center">
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryLeft"> 
                                    <h2>Turn Your Dealership Into a Trusted Mobility Hub</h2>
                                    <p>Position your dealership as a trusted mobility provider in your 
                                        community by offering flexible rental solutions that attract 
                                        and retain customers.A seamless, transparent rental experience builds trust while keeping you in full control 
                                        of policies. Stand out with high-tech, self-serve rental options that enhance your 
                                        brand’s reputation. By offering an app-powered rental system, you can convert 
                                        ride-sharing and car-sharing users into loyal customers who return to you
                                    </p>

                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryRight" >
                                <img className='img-fluid' src="/img/Solutions/mobility_hub.webp" alt="rent id"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceFormerMain */}

            {/* START choiceFormerMain */}
            <section  className="choiceFormerMain choiceDesktopMain blackChoiceMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headChoiceFormer">
                                <h2>Single Platform for Test Drives, Rentals & Subscriptions</h2>
                                <p>The only rental platform you’ll ever need</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <ul className="nav nav-tabs main-tabs-ai">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="tab" href="#choiceFormer_1">
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent id"/>rent<span>direct</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_2">
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>rent<span>ID</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_3">
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent id"/>rent<span>shield</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_4">
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent id"/>rent<span>AI</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_5">
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent id"/>rent<span>success</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_6">
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent id"/>rent<span>academy</span>
                                    </a>
                                </li>
                            </ul>
                        
                            <div className="tab-content">
                                {/* START Tab 1 */}
                                <div className="tab-pane active" id="choiceFormer_1">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rentDirect"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Rental Management Platform</h3>
                                                    <p>RentDirect is a complete rental ecosystem for the modern world, integrating customizable workflows and tools tailored with your custom platform settings.</p>
                                                    <p>Practically driving itself with automations, dynamic data, and AI-powered intelligence, RentDirect delivers efficiency, flexibility, and scalable growth—unlike traditional rental software.</p>
                                                </div>        

                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* END Tab 1 */}

                                {/* START Tab 2 */} 
                                <div className="tab-pane fade" id="choiceFormer_2">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Trust & Safety Workflows</h3>
                                                    <p>RentID gives hosts full control over who gets behind the wheel. With AI-driven screening, real-time ID verification, and personal insurance validation, only qualified renters gain access.</p>
                                                    <p>The DriverIQ™ Score assesses risk, while our National BlockList stops repeat offenders. Seamlessly integrated, these security workflows keep rentals safe without delaying bookings.</p>
                                                </div>                                            
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rent-id">Learn About RentID
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 2 */}

                                {/* START Tab 3 */}
                                <div className="tab-pane fade" id="choiceFormer_3">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>

                                                <div className='choiceFormerTop'>
                                                    <h3>Coverage & Protection Plans</h3>
                                                    <p>RentShield™ is built into every rental, giving you automatic protection without extra steps. Whether you need liability-only or full physical damage coverage, or roadside assistance, your fleet stays covered—without the need of manual intervention.</p>
                                                </div>



                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 3 */}

                                {/* START Tab 4 */} 
                                <div className="tab-pane fade" id="choiceFormer_4">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Automated Rental Tasks </h3>
                                                    <p>Meet Rentii™ — your AI-powered back-office rental partner handling everything from renter support to booking management, and even your rental policy enforcement so you don’t have to.</p>
                                                    <p>Tap into the power of AI Rental Agent support for your rental business.</p>
                                                </div>
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 4 */}

                                {/* START Tab 5 */}
                                <div className="tab-pane fade" id="choiceFormer_5">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Rental Back Office Solutions</h3>
                                                    <p>Providing real-time support and structured policy management to help rental operators handle disputes, violations, and claims effortlessly.</p>
                                                    <p>Our expert-backed Resolution Center and rental back office ensure seamless fleet coordination, compliance, and renter management, so you can focus on growth.</p>
                                                </div>
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 5 */}


                                {/* START Tab 6 */} 
                                <div className="tab-pane fade" id="choiceFormer_6">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rentAcademy"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Learn, Teach, & Duplicate Hub</h3>
                                                    <p>Whether you’re launching your first rental or managing a growing fleet, RentAcademy™ provides expert-led courses, industry insights, and step-by-step guides to help you run a more profitable rental business.</p>
                                                    <p>We’re here every step of the way!</p>
                                                </div>
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 6 */}
                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceFormerMain */}

            {/* START choiceMobileMain */}
            <section  className="choiceFormerMain choiceMobileMain blackChoiceMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headChoiceFormer">
                                <h2>Single Platform for Test Drives, Rentals & Subscriptions</h2>
                                <p>The only rental platform you’ll ever need</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="choiceAccordian">
                            <Accordion defaultActiveKey="0">
                                {/* start 1 */}
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent id"/>rent<span>direct</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rentDirect"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'>
                                                <h3>Rental Management Platform</h3>
                                                <p>RentDirect is a complete rental ecosystem for the modern world, integrating 
                                                customizable workflows and tools tailored with your custom platform settings.</p>
                                                <p>Practically driving itself with automations, dynamic data, and AI-powered 
                                                intelligence, RentDirect delivers efficiency, flexibility, and scalable 
                                                growth—unlike traditional rental software.</p>

                                                <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 2 */}
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>rent<span>ID</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rentId"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                        <h3>Trust & Safety Workflows</h3>
                                                        <p>RentID gives hosts full control over who gets behind the wheel. With AI-driven screening, 
                                                        real-time ID verification, and personal insurance validation, only qualified renters 
                                                        gain access. </p>
                                                        <p>The DriverIQ™ Score assesses risk, while our National BlockList stops repeat offenders. 
                                                        Seamlessly integrated, these security workflows keep rentals safe without 
                                                        delaying bookings.</p>
                                                                                        
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rent-id">Learn About RentID
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 3 */}
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent id"/>rent<span>shield</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rentId"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>
                
                                                        <h3>Coverage & Protection Plans</h3>
                                                        <p>RentShield™ is built into every rental, giving you automatic protection without extra steps. 
                                                            Whether you need liability-only or full physical damage coverage, or roadside assistance, 
                                                            your fleet stays covered—without the need of manual intervention.</p>
                                                


                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 4 */}
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent id"/>rent<span>AI</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rentId"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>

                                                        <h3>Automated Rental Tasks </h3>
                                                        <p>Meet Rentii™ — your AI-powered back-office rental partner handling everything from 
                                                        renter support to booking management, and even your rental policy enforcement so 
                                                        you don’t have to.</p>
                                                        <p>Tap into the power of AI Rental Agent support for your rental business.</p>
                                        
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 5 */}
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent id"/>rent<span>success</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'> 
                                                <h3>Rental Back Office Solutions</h3>
                                                <p>Providing real-time support and structured policy management to help rental 
                                                    operators handle disputes, violations, and claims effortlessly.</p>
                                                <p>Our expert-backed Resolution Center and rental back office ensure seamless 
                                                    fleet coordination, compliance, and renter management, so you can focus on growth.</p>
                                        
                                                <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 6 */}
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent id"/>rent<span>academy</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rentAcademy"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                        <h3>Learn, Teach, & Duplicate Hub</h3>
                                                        <p>Whether you’re launching your first rental or managing a growing fleet, RentAcademy™ provides expert-led courses, industry insights, and step-by-step guides to help you run a more profitable rental business.</p>
                                                        <p>We’re here every step of the way!</p>
                                
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                {/* end 6 */}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceMobileMain */}


            {/* START rentalbackOfficeMain */}
            <section className='rentalbackOfficeMain'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='rentalbackOfficeHead'>
                                <h6>OPERATIONAL SOLUTIONS</h6>
                                <h2>Rental Back Office</h2>
                                <p> Optimize operations with a fully integrated rental back-office solution that supports your 
                                team and simplifies management. Automated workflows resolve issues faster with a centralized 
                                system that handles the heavy lifting—so you can focus on growth.</p>
                            </div>
                        </div>
                    </div>



                    <div className='row'>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>AI Rental Agents</h3>
                                <p>AI rental super agent that handles tasks, solves problems, and keeps your business moving.</p>
                                 <a href="/rentai">Learn about AI Rental Agents</a> 
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Tolls & Tickets </h3>
                                <p>Automatically track, charge, and manage tolls and violations, ensuring accurate billing.</p>
                                 <a href="/rentsuccess#tolls_and_tickets">Learn about Tolls & Tickets </a> 
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Roadside Assistance </h3>
                                <p>24/7 roadside coverage, including towing, jump-starts, and lockout assistance.</p>
                                <a href="/rentshield#NationalRoadsideAssistance">Learn about Roadside Assistance </a>  
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Guest Communication</h3>
                                <p>Enhance customer experience with automated messages, real-time updates, and instant responses.</p>
                                 <a href="/rentsuccess#OnRentGuidelines">Learn about Guest Communication</a> 
                            </div>
                        </div>

                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Resource Center</h3>
                                <p>Centralized hub for renter education to streamline  operations & reduce inquiries.</p>
                                 <a href="/rentsuccess#BusinessEmpowerment">Learn about Resource Center</a>  
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Success Manager</h3>
                                <p>Dedicated support to increase utilization, revenue and grow with expert insights.</p>
                                <a href="/rentsuccess#businessEmpowerment_2">Learn about Success Manager</a>  
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Technical Support</h3>
                                <p>Ensure smooth operations with expert assistance, system integrations and troubleshooting.</p>
                                 <a href="/rentsuccess#TechnicalSupport">Learn about Technical Support</a> 
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Digital Marketing</h3>
                                <p>Attract more renters with targeted campaigns, automated re-marketing, and insights.</p>
                                <a href="/rentsuccess#businessEmpowerment_3">Learn about Digital Marketing</a> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END rentalbackOfficeMain */}

            {/* START industryTrustMain */}
            <section className="industryTrustMain">
                <div className="container">
                    <div className='industryTrustOuter'>
                        <div className='row align-items-center'>
                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustLeft'>
                                    <h2>Industry trust<span> and transparency</span> </h2>
                                </div>
                            </div>
                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustRight'>
                                    <ul>
                                        <li>
                                            <img className="img-fluid" width="140px" src="/img/AnoucementPage/industryTrust_1.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="164px" src="/img/AnoucementPage/industryTrust_2.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="146px" src="/img/AnoucementPage/industryTrust_3.png" alt="Industry trust and transparency" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END industryTrustMain */}
            
            {/* START resolutionAnounceMain */}
            <section className='resolutionAnounceMain'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='resolutionAnounceHead'>
                                <h6>ADMINISTRATIVE SUPPORT</h6>
                                <h2>Rentid Resolution Center</h2>
                                <p>Managing rental disputes is costly and time-consuming. Rentid’s Resolution Center streamlines incident submission, tracking, and resolution for violations, damages, and claims—all in one platform—with automated invoicing and payment recovery.</p>
                            </div>
                        </div>
                    </div>

                    <div className='row align-items-center'>
                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                            <div className="resolutionAnounceLeft">
                                <div className='row align-items-center'>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>On Rent Guest Violations</h3>
                                            <p>Submit incidents for infractions of the rental agreement, including late returns, 
                                            mileage overages, and vehicle misuse.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>Submit Insurance Claims</h3>
                                            <p>Process and track insurance claims directly within the platform, 
                                            reducing paperwork and speeding up resolutions.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>Issue Guest Refunds</h3>
                                            <p>Control refunds seamlessly, whether issuing full or partial reimbursements, 
                                            handling approvals, or tracking disputes.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>Report Guest Behavior</h3>
                                            <p>Report guest behavior to improve risk assessment, prevent future issues, and maintain high rental standards.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="resolutionAnounceBottom">
                                     <a className="btn btnTransparent_5" href="/rentsuccess#ResolutionCenter">Explore The Resolution Center 
                                     <img src="/img/AnoucementPage/arrow-right.svg" alt="icon"/></a>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                            <div className="resolutionAnounceRight">
                                <figure>
                                    <img className='img-fluid' src="/img/AnoucementPage/resolutionAnounceRight.png" alt="rent id"/>
                                </figure>
                            </div>

                        </div>
                    
                    </div>

                </div>
            </section>
            {/* END resolutionAnounceMain */}


            {/* START trackingTelematicsMain */}
            <section className="trackingTelematicsMain">
                <div className="container">
                    <div className='row align-items-center'>

                        <div className='col-lg-6 col-md-12 col-sm-12'>
                            <div className='trackingTelematicsLeft'>
                                <ul>
                                    <li>
                                        <img className="img-fluid" width="105px" src="/img/AnoucementPage/trackingTelematics_1.png" alt="Industry trust and transparency" />
                                    </li>
                                    <li>
                                        <img className="img-fluid" width="121px" src="/img/AnoucementPage/trackingTelematics_2.png" alt="Industry trust and transparency" />
                                    </li>
                                    <li>
                                        <img className="img-fluid" width="123px" src="/img/AnoucementPage/trackingTelematics_3.png" alt="Industry trust and transparency" />
                                    </li>
                                    <li>
                                        <img className="img-fluid" width="123px" src="/img/AnoucementPage/trackingTelematics_4.png" alt="Industry trust and transparency" />
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className='col-lg-6 col-md-12 col-sm-12'>
                            <div className='trackingTelematicsRight'>
                                <h6>INTEGRATIONS</h6>
                                <h2>Tracking and Telematics</h2>
                                <p>Rentid’s built-in telematics provides real-time tracking, driver behavior insights, and remote security controls—without needing third-party systems. Protect your fleet, reduce risk, and optimize vehicle performance, all from one platform.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* END trackingTelematicsMain */}
            <EasySetup/>

            {/* <CarRentalFaq/> */}

            <ScrollingAnounce/>


            <PopularBlog/>

            <Footer/>
        </>
    )
}

export default AutoDealerships;